import { TextField, styled } from "@mui/material";

export const StyledTextFiled: any = styled(TextField)`
  .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input {
    cursor: ${({ $readOnly }: any) => ($readOnly ? "not-allowed" : "text")};
  }
`;
